// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_su-5";
export var filledCircle = "_su-4";
export var historyEntry = "_su-3";
export var messageSideLeft = "_su-1";
export var messageSideRight = "_su-2";
export var orderTrackingCarouselWrapper = "_su-6";
export var orderTrackingInfoContainer = "_su-0";